import { Injectable, Signal } from '@angular/core';
import { ISummaryData, ISummaryLoanDetails, ISummaryModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { ISummaryState, SummaryActions, SummarySelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class SummaryStore extends StateAccessService<ISummaryState> {
  readonly state$: Observable<ISummaryState>;

  readonly data$$: Signal<ISummaryData>;
  readonly model$$: Signal<ISummaryModel>;

  readonly loadDetails$$: Signal<ISummaryLoanDetails>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(SummarySelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(SummarySelectors.data);
    this.loadDetails$$ = this.stateFacade.selectSignal$(SummarySelectors.loanData);
  }

  dispatchSummaryReset() {
    this.stateFacade.dispatch(SummaryActions.reset());
  }
  dispatchSummaryLoad() {
    this.stateFacade.dispatch(SummaryActions.load());
  }
  dispatchSummaryLoadSuccess({ model, data }: { model: ISummaryModel; data: ISummaryData }) {
    this.stateFacade.dispatch(SummaryActions.loadSuccess({ model, data }));
  }
}
